import { CircularProgress } from "@mui/material";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";

interface SubscriptionManagementModalFooterProps {
    onClose: () => void;
    onSave: () => Promise<void>;
    hasChanges: boolean;
    isProcessingJobInProgress: boolean;
}

const SubscriptionManagementModalFooter = ({
    onClose,
    onSave,
    hasChanges,
    isProcessingJobInProgress,
}: SubscriptionManagementModalFooterProps) => {
    const [t] = useTranslation();

    const handleSave = async () => {
        try {
            await onSave();
            onClose();
        } catch (error) {
            // Error is already handled in the container with toast
        }
    };

    return (
        <div className="modal-footer">
            <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}>
                {isProcessingJobInProgress && (
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <CircularProgress size={20} />
                        <span style={{ fontSize: "14px", color: "#666" }}>{t("Common.ProcessingInProgress")}</span>
                    </div>
                )}
            </div>
            <div style={{ display: "flex", gap: "12px" }}>
                <StyledButton onClick={onClose} buttonType="secondary">
                    {t("Common.Close")}
                </StyledButton>
                <StyledButton
                    onClick={handleSave}
                    buttonType="primary"
                    disabled={!hasChanges || isProcessingJobInProgress}
                >
                    {t("Common.Save")}
                </StyledButton>
            </div>
        </div>
    );
};

export default SubscriptionManagementModalFooter;
